import {
  AuthApi,
  BffApi,
  ConfirmPhoneDTOAPIModel,
  ToggleApi,
  UpdatePhoneDTOAPIModel,
  VerificationApi,
} from '@/generated/api/fps/api';
import { InitialData, ConfirmationData } from '@/model/auth/types';
import { FeatureFlags, Partner } from '@/model/global/types';
import { normalizeDateTime } from '@/utils/api';

import { apiConfigurationFactory } from './utils/auth.provider';
import { parsePhone, parsePhoneInfo } from './utils/phone';

const authAPI = new AuthApi(apiConfigurationFactory('auth'));
const authAPINoError = new AuthApi(apiConfigurationFactory('no-forbidden'));
const bffAPI = new BffApi(apiConfigurationFactory('auth'));
const verificationAPI = new VerificationApi(apiConfigurationFactory('auth'));
const toggleAPI = new ToggleApi(apiConfigurationFactory('public'));

export const auth = async (requestToken: string): Promise<string> =>
  (await authAPI.authControllerLogin({ token: requestToken }))?.token;
export const logout = (): Promise<void> => authAPINoError.authControllerLogout();

const parseConfirmationData = (data: ConfirmationData, res: Response): ConfirmationData => ({
  ...data,
  validTill: normalizeDateTime(data.validTill, { res }),
  resendAfter: normalizeDateTime(data.resendAfter, { res }),
});

const parsePartner = (data: Partner, res: Response): Partner => ({
  ...data,
  created: normalizeDateTime(data.created, { res }),
});

export const queryAuthData = async (): Promise<InitialData> => {
  const res = await bffAPI.bffControllerInitRaw();
  const data = await res.value();
  return {
    ...data,
    confirmation: data.confirmation?.validTill ? parseConfirmationData(data.confirmation, res.raw) : data.confirmation,
    phone: data.phone ? parsePhoneInfo(data.phone) : undefined,
    status: data.status,
    partner: data.partner ? parsePartner(data.partner, res.raw) : undefined,
  };
};

export const queryToggle = async (): Promise<Record<FeatureFlags, boolean>> => toggleAPI.toggleControllerGetFlags();

export const updatePhone = async ({ phone }: UpdatePhoneDTOAPIModel): Promise<ConfirmationData> => {
  const res = await verificationAPI.verificationControllerUpdateRaw({ updatePhoneDTOAPIModel: { phone: `7${phone}` } });
  return parseConfirmationData(await res.value(), res.raw);
};

export const confirmPhone = async (data: ConfirmPhoneDTOAPIModel): Promise<string> =>
  parsePhone((await verificationAPI.verificationControllerVerifyPhone(data)).phone);
